//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QfPNumberDataFormat",
    props: {
        valueErrMsg: { type: String, default: "" },
        label: { type: String, default: "" },
        labelErrMsg: { type: String, default: "" },
        tooltip: { type: String, default: "" },
        disable: { type: Boolean, default: false },
        intOrDecimal: { type: String, default: "integer" },
        nrDecimals: { type: Number, default: undefined },
        errMsgDecimal: { type: String, default: "" }
    },
    computed: {
        intOrDecimalVal: {
            get() {
                return this.intOrDecimal;
            },
            set(val) {
                this.$emit("intOrDecimalVal", val);
            }
        },
        errMsgValue: {
            get() {
                return this.valueErrMsg;
            },
            set(val) {
                this.$emit("errMsgChange", val);
            }
        },
        nrDecimalsVal: {
            get() {
                return this.nrDecimals;
            },
            set(val) {
                this.$emit("setNrDecimals", val ? Number(val) : undefined);
            }
        },
        errMsgDecimalValue: {
            get() {
                return this.errMsgDecimal;
            },
            set(val) {
                this.$emit("setErrMsgDecimalValue", val);
            }
        }
    },
    methods: {
    }
};
